module.exports = __webpack_public_path__ + "img/logo.0034274d.png";